import React, { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Badge,
} from 'reactstrap'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import * as notificationActionCreators from '../../../redux/notifications'
import subscriptionActionCreators from '../../../redux/css-admin/subscriptionManager/operations'
import * as modalActionsCreators from '../../../redux/modal'
import { extractExpirationInfo } from '../../../lib/util'
import SkuGrid from './SkuGrid'
import LicenseGrid from './licenseGrid/LicenseGrid'
import UnassignedLicenseGrid from './UnassignedLicenseGrid'
import CanceledLicenseGrid from './CanceledLicenseGrid'
import { ErrorBoundary, Loading } from 'components'
import SubscriptionSummary from './SubscriptionSummary'
import Assign from './setupLicense/Assign'
import EditLicenseModal from '../licenses/EditLicenseModal'

const SubscriptionManager = props => {
  const {
    isLoading,
    match,
    openModal,
    reloadSubscription,
    subscriptions,
  } = props

  const [selectedLicense, setSelectedLicense] = useState(null)
  const [setupModalOpen, setSetupModalOpen] = useState(false)
  const [editModalOpen, setEditModalOpen] = useState(false)

  // mount
  useEffect(() => {
    loadSubscription()
  }, [])

  //DidUpdate
  useEffect(() => {
    loadSubscription()
  }, [match.params.id])

  const getSubscription = () => {
    if (!subscriptions) return null
    const subscriptionId = match.params.id

    const subscription = subscriptions.get(subscriptionId)
    if (!subscriptions || !subscriptions.has(subscriptionId)) {
      return null
    }
    return subscription
  }

  const loadSubscription = () => {
    const subscriptionId = match.params.id
    if (subscriptionId) {
      reloadSubscription(subscriptionId)
    }
  }

  const backToSearch = notFound => {
    const pathname = match.path
    props.push(pathname.substring(0, pathname.lastIndexOf('/')))
  }

  const goToSubscription = subscriptionId => {
    const pathname = match.path
    props.push(
      `${pathname.substring(0, pathname.lastIndexOf('/'))}/${subscriptionId}`,
    )
  }

  const setupLicense = license => {
    setSelectedLicense(license)
    setSetupModalOpen(true)
  }

  const toggleSetupModal = () => setSetupModalOpen(!setupModalOpen)

  const toggleEditModal = license => {
    !editModalOpen ? setSelectedLicense(license) : setSelectedLicense(null)
    setEditModalOpen(!editModalOpen)
  }

  const openRebalanceModal = () => {
    const subscription = getSubscription()
    if (subscription) {
      openModal('RebalanceSubscriptionModal', {
        subscription,
      })
    }
  }

  const subscription = getSubscription()
  if (!subscription) return null
  const expiration = extractExpirationInfo(subscription, 'YYYY-MM-DD')

  return (
    <ErrorBoundary>
      <p>
        <Button color="primary" onClick={() => backToSearch(false)} outline>
          <i className="fas fa-chevron-left" />
          &nbsp; Back to Search
        </Button>
      </p>
      <Loading isLoading={isLoading} />
      <Row style={{ backgroundColor: '#002855' }}>
        <Col>
          <h2 className="mt-2 text-light">
            Subscription&nbsp;
            <Badge color="light">SS: {subscription.id}</Badge>&nbsp;
            <Badge color="light">NS: {subscription.nsSubscriptionId}</Badge>
            {subscription.isArchive && (
              <Badge color="light" className="float-right">
                Archived
              </Badge>
            )}
          </h2>
        </Col>
      </Row>
      <SubscriptionSummary
        goToSubscription={goToSubscription}
        showRebalanceModal={openRebalanceModal}
        subscription={subscription}
      />
      <fieldset>
        <legend>
          Skus&nbsp;
          <Badge color="info">
            {subscription.skus.reduce((agg, curr) => agg + curr.qty, 0)}
          </Badge>
        </legend>
        <SkuGrid skus={subscription.skus} />
      </fieldset>

      <fieldset>
        <legend>
          Unassigned Licenses&nbsp;
          <Badge color="info">{subscription.licensesToAssign.length}</Badge>
        </legend>

        <UnassignedLicenseGrid
          licenses={subscription.licensesToAssign}
          onSetupLicense={setupLicense}
        />
        {selectedLicense && setupModalOpen && (
          <Modal
            backdrop="static"
            centered
            fade
            isOpen={true}
            size="lg"
            toggle={toggleSetupModal}
          >
            <ModalHeader toggle={toggleSetupModal}>Setup License</ModalHeader>
            <ModalBody>
              <Assign
                subscriptionId={subscription.id}
                clearSelectedLicense={() => setSelectedLicense(null)}
                license={selectedLicense}
                updateSubscription={loadSubscription}
                toggle={toggleSetupModal}
              />
            </ModalBody>
          </Modal>
        )}
      </fieldset>

      <fieldset>
        <legend>
          Assigned Licenses&nbsp;
          <Badge color="info">{subscription.licenses.length}</Badge>
        </legend>
        <LicenseGrid
          licenses={subscription.licenses}
          onEditLicense={toggleEditModal}
          subscription={subscription}
        />
        {selectedLicense && editModalOpen && (
          <EditLicenseModal
            isOpen={editModalOpen}
            licenseId={selectedLicense.id}
            siteId={selectedLicense.siteId}
            subscription={subscription}
            toggle={toggleEditModal}
            updateSubscription={loadSubscription}
          />
        )}
      </fieldset>
      <fieldset>
        <legend>
          Canceled Licenses&nbsp;
          <Badge color="info">{subscription.canceledLicenses.length}</Badge>
        </legend>
        <CanceledLicenseGrid
          licenses={subscription.canceledLicenses}
          onEditLicense={toggleEditModal}
          subscription={subscription}
        />
      </fieldset>
    </ErrorBoundary>
  )
}

const mapStateToProps = ({ subscriptionManager }) => {
  return {
    ...subscriptionManager,
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      ...notificationActionCreators,
      ...subscriptionActionCreators,
      ...modalActionsCreators,
      push,
    },
    dispatch,
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionManager)



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/Subscription.js